"use client";

import { Progress as ProgressPrimitive } from "@base-ui/react/progress";

import { cn } from "../lib/utils";

function Progress({
  className,
  value,
  ...props
}: Omit<ProgressPrimitive.Root.Props, "value"> & {
  value?: number | null;
}) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={value ?? null}
      className={cn(
        "bg-surface-hover relative h-2 w-full overflow-hidden rounded-full",
        className,
      )}
      {...props}
    >
      {/* The Track must carry an explicit height: Base UI sizes the Indicator
          with inline `height: inherit`, which inherits the Track's *specified*
          height — with `absolute inset-0` that was `auto`, so the fill
          rendered 0px tall and the bar looked permanently empty. */}
      <ProgressPrimitive.Track
        data-slot="progress-track"
        className="h-full w-full"
      >
        <ProgressPrimitive.Indicator
          data-slot="progress-indicator"
          className="bg-primary h-full transition-all"
        />
      </ProgressPrimitive.Track>
    </ProgressPrimitive.Root>
  );
}

export { Progress };
